import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface AdminConversation {
  project_id: string;
  project_name: string;
  project_status: string;
  client_name: string;
  client_id: string;
  last_message_preview: string | null;
  last_message_at: number | null;
  unread_count: number;
}

export interface AdminMessageAttachment {
  url: string;
  name: string;
  type: string;
  size: number;
}

export interface AdminMessage {
  id: string;
  projectId: string;
  content: string;
  type: string;
  isFromClient: boolean;
  senderName: string;
  readAt: number | null;
  createdAt: number;
  attachments: AdminMessageAttachment[];
}

export const messageAdminService = {
  async listConversations(): Promise<AdminConversation[]> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/messages/conversations`
    );
    if (!result || result.error) {
      throw new Error(result?.error || 'Error al cargar conversaciones');
    }
    return result.data || [];
  },

  async listMessages(
    projectId: string
  ): Promise<{ messages: AdminMessage[]; clientId: string }> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/messages/${projectId}`
    );
    if (!result || result.error) {
      throw new Error(result?.error || 'Error al cargar mensajes');
    }
    return result.data;
  },

  async sendMessage(data: {
    projectId: string;
    content: string;
    attachments?: AdminMessageAttachment[];
  }): Promise<AdminMessage> {
    const result = await authService.fetchWithAuth(`${API_URL}/api/internal/messages`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    if (!result || result.error) {
      throw new Error(result?.error || 'Error al enviar');
    }
    return result.data;
  },

  async markRead(projectId: string): Promise<void> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/messages/${projectId}/read`,
      { method: 'POST' }
    );
    if (result && result.error) {
      throw new Error(result.error);
    }
  },

  async presignUpload(data: { filename: string; contentType: string }) {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/messages/presign-upload`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      }
    );
    if (!result || result.error) {
      throw new Error(result?.error || 'Error al generar URL');
    }
    return result.data as {
      upload_url: string;
      public_url: string;
      key: string;
      expires_at: number;
    };
  },
};